import { requestGet } from '@/utils/request';

const api = {
	LIST: '/op/product_order_list',
};

export async function productOrderList(queryParams) {
	return requestGet(api.LIST, queryParams);
}
